// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-users.modal-verificate{
    width: 100% !important;
    height: 99% !important;
}

.txt-title-user-box-RelationTechDevice.modal-verificate{
    text-align: center;
    word-wrap: break-word;
    width: 80%;
}
.user-box-RelationTechDevice{
    height: 20% !important;
}
.user-box-RelationTechDevice {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 20%;
}
.form-RelationTechDevice-box {
    position: relative;
    display: block;
    width: 85%;
    height: 90%;
  }
.form-RelationTechDevice-box .user-box-RelationTechDevice .label-RelationTechDevice {
    position: absolute;
    top: 0px !important;
    left: 0;
    padding: 10px 0;
    font-size: 10px !important;
    font-weight: bolder;
    color: #003757;
    pointer-events: none;
    transition: .5s;
  }
  .form-RelationTechDevice-box .user-box-RelationTechDevice input:focus ~ .label-RelationTechDevice, .form-RelationTechDevice-box .user-box-RelationTechDevice input:valid ~ .label-RelationTechDevice {
    top: -25px !important;
    left: 0px;
    color: #003757;
    font-size: 12px;
  }



  
  .form-RelationTechDevice-box .user-box-RelationTechDevice input:focus ~ .label-RelationTechDevice,
.form-RelationTechDevice-box .user-box-RelationTechDevice input:valid ~ .label-RelationTechDevice,
.form-RelationTechDevice-box .user-box-RelationTechDevice .active {
    top: -25px !important;
    left: 0px;
    font-size: 12px;
}


.form-RelationTechDevice-box .user-box-RelationTechDevice input {
  width: 100%;
  padding: 10px 0;
  font-size: 16px;
  color: #505050;
  margin-bottom: 30px;
  border: none;
  border-bottom: 2px solid #003757;
  border-right: 2px solid #003757;
  outline: none;
  background: transparent;
}

.form-RelationTechDevice-box .user-box-RelationTechDevice input:focus ~ .label-RelationTechDevice,
.form-RelationTechDevice-box .user-box-RelationTechDevice input:valid ~ .label-RelationTechDevice {
  top: -10px;
  left: 0;
  color: #003757;
  font-size: 12px;
}
.user-box-RelationTechDevice .form-msg-error{
  color: #ff4646;
  position: absolute;
  left:0;
  /* top:10% */
  /* bottom: 0%; */
  background-color: rgba(255, 211, 211, 0.64);
  width: 99.5%;
  text-align: center;
  border: 2px solid #ff4646;
  border-radius: 0px 0px 5px 5px;
  height: 45%;
  bottom: -15%;
  z-index: 3;
  border-top: none;

}
.head-card-RelationTechDevice-modal-create {
  position: relative;
  height: 10%;
  width: 100%;
  background: rgba(195,195,195);
  background: #003757;
  display: flex;
  justify-content: center;
  align-items: center;
}
.checkbox-RelationTechDevice{
  height: 25px !important;
  
}
.checkbox-RelationTechDevice:hover{
  cursor: pointer;
}
.label-checkbox-RelationTechDevice{
  left: 55%;
  position: absolute;
  top: 10%;
  color:#003757
}`, "",{"version":3,"sources":["webpack://./src/components/portafolio-components/styles/ModalCreateRelationTechDevice.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;AACd;AACA;IACI,sBAAsB;AAC1B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,WAAW;EACb;AACF;IACI,kBAAkB;IAClB,mBAAmB;IACnB,OAAO;IACP,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,SAAS;IACT,cAAc;IACd,eAAe;EACjB;;;;;EAKA;;;IAGE,qBAAqB;IACrB,SAAS;IACT,eAAe;AACnB;;;AAGA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;AACzB;;AAEA;;EAEE,UAAU;EACV,OAAO;EACP,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;EAC3C,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;;AAElB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,uBAAuB;;AAEzB;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR;AACF","sourcesContent":[".card-users.modal-verificate{\r\n    width: 100% !important;\r\n    height: 99% !important;\r\n}\r\n\r\n.txt-title-user-box-RelationTechDevice.modal-verificate{\r\n    text-align: center;\r\n    word-wrap: break-word;\r\n    width: 80%;\r\n}\r\n.user-box-RelationTechDevice{\r\n    height: 20% !important;\r\n}\r\n.user-box-RelationTechDevice {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 20%;\r\n}\r\n.form-RelationTechDevice-box {\r\n    position: relative;\r\n    display: block;\r\n    width: 85%;\r\n    height: 90%;\r\n  }\r\n.form-RelationTechDevice-box .user-box-RelationTechDevice .label-RelationTechDevice {\r\n    position: absolute;\r\n    top: 0px !important;\r\n    left: 0;\r\n    padding: 10px 0;\r\n    font-size: 10px !important;\r\n    font-weight: bolder;\r\n    color: #003757;\r\n    pointer-events: none;\r\n    transition: .5s;\r\n  }\r\n  .form-RelationTechDevice-box .user-box-RelationTechDevice input:focus ~ .label-RelationTechDevice, .form-RelationTechDevice-box .user-box-RelationTechDevice input:valid ~ .label-RelationTechDevice {\r\n    top: -25px !important;\r\n    left: 0px;\r\n    color: #003757;\r\n    font-size: 12px;\r\n  }\r\n\r\n\r\n\r\n  \r\n  .form-RelationTechDevice-box .user-box-RelationTechDevice input:focus ~ .label-RelationTechDevice,\r\n.form-RelationTechDevice-box .user-box-RelationTechDevice input:valid ~ .label-RelationTechDevice,\r\n.form-RelationTechDevice-box .user-box-RelationTechDevice .active {\r\n    top: -25px !important;\r\n    left: 0px;\r\n    font-size: 12px;\r\n}\r\n\r\n\r\n.form-RelationTechDevice-box .user-box-RelationTechDevice input {\r\n  width: 100%;\r\n  padding: 10px 0;\r\n  font-size: 16px;\r\n  color: #505050;\r\n  margin-bottom: 30px;\r\n  border: none;\r\n  border-bottom: 2px solid #003757;\r\n  border-right: 2px solid #003757;\r\n  outline: none;\r\n  background: transparent;\r\n}\r\n\r\n.form-RelationTechDevice-box .user-box-RelationTechDevice input:focus ~ .label-RelationTechDevice,\r\n.form-RelationTechDevice-box .user-box-RelationTechDevice input:valid ~ .label-RelationTechDevice {\r\n  top: -10px;\r\n  left: 0;\r\n  color: #003757;\r\n  font-size: 12px;\r\n}\r\n.user-box-RelationTechDevice .form-msg-error{\r\n  color: #ff4646;\r\n  position: absolute;\r\n  left:0;\r\n  /* top:10% */\r\n  /* bottom: 0%; */\r\n  background-color: rgba(255, 211, 211, 0.64);\r\n  width: 99.5%;\r\n  text-align: center;\r\n  border: 2px solid #ff4646;\r\n  border-radius: 0px 0px 5px 5px;\r\n  height: 45%;\r\n  bottom: -15%;\r\n  z-index: 3;\r\n  border-top: none;\r\n\r\n}\r\n.head-card-RelationTechDevice-modal-create {\r\n  position: relative;\r\n  height: 10%;\r\n  width: 100%;\r\n  background: rgba(195,195,195);\r\n  background: #003757;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.checkbox-RelationTechDevice{\r\n  height: 25px !important;\r\n  \r\n}\r\n.checkbox-RelationTechDevice:hover{\r\n  cursor: pointer;\r\n}\r\n.label-checkbox-RelationTechDevice{\r\n  left: 55%;\r\n  position: absolute;\r\n  top: 10%;\r\n  color:#003757\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
